const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}



// --- Custom Filter Toggle Injection ---
// Dynamically creates the filter toggle button and applies pixel-perfect styling 
// to the facets layout, without blindly overwriting the original facets.liquid file.
window.addEventListener('DOMContentLoaded', () => {
  const initCustomFilter = () => {
    // Only apply on desktop vertical layout (mobile already has a drawer)
    //if (window.innerWidth < 750) return;
    const isVertical = document.querySelector('.facets-vertical') !== null;
    if (!isVertical) return;

    // Target the sorting container to align Filter button with Sort By
    const sortContainer = document.querySelector('.facets-vertical-sort') || document.querySelector('.facet-filters.sorting')?.parentElement;
    if (!sortContainer) return;

    if (!document.querySelector('.custom-filter-toggle')) {
      const toggleBtn = document.createElement('button');
      toggleBtn.className = 'custom-filter-toggle';
      toggleBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10 5H3" stroke="#1A1F2E" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 19H3" stroke="#1A1F2E" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 3V7" stroke="#1A1F2E" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 17V21" stroke="#1A1F2E" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 12H12" stroke="#1A1F2E" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 19H16" stroke="#1A1F2E" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 5H14" stroke="#1A1F2E" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 10V14" stroke="#1A1F2E" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 12H3" stroke="#1A1F2E" stroke-width="2.53" stroke-linecap="round" stroke-linejoin="round"/></svg> Filter`;
      
      toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const aside = document.getElementById('main-collection-filters');
        if(aside) aside.classList.toggle('is-visible');
      });

      // Insert at the beginning of the sort container to match the exact screenshot layout
      sortContainer.insertBefore(toggleBtn, sortContainer.firstChild);
    }
  };

  initCustomFilter();

  // Dawn replaces the product grid and filters via AJAX. We re-inject button if it's overwritten.
  const mainContent = document.getElementById('MainContent') || document.body;
  const observer = new MutationObserver((mutations) => {
    let shouldInject = false;
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldInject = true;
        break;
      }
    }
    if (shouldInject) {
      setTimeout(initCustomFilter, 50);
    }
  });
  observer.observe(mainContent, { childList: true, subtree: true });

  // Close filter dropdown when clicking outside
  document.addEventListener('click', (e) => {
    const aside = document.getElementById('main-collection-filters');
    const toggle = document.querySelector('.custom-filter-toggle');
    if (aside && aside.classList.contains('is-visible')) {
      if (!aside.contains(e.target) && (!toggle || !toggle.contains(e.target))) {
        aside.classList.remove('is-visible');
      }
    }
  });

  // Inject Custom CSS dynamically
  const style = document.createElement('style');
  style.innerHTML = `
      .facets-vertical {
        position: relative !important;
        display: block !important; 
      }
      .facets-vertical .facets-wrapper {
        padding: 0 !important;
        width: 0 !important;
      }
      .facets-vertical-sort {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        width: 100% !important;
        margin-bottom: 24px !important;
      }
      .custom-filter-toggle {
        display: flex;
        align-items: center;
        border: none !important;
        cursor: pointer;
        transition: background-color 0.3s ease !important;
        box-shadow: none !important;
        min-height: unset !important;
        border-radius: 10px;
        background: #f8f2e4;
        padding: 4px 24px;
        height: 38px;
        font-family: 'Test Söhne Medium';
        font-family: var(--font-heading-family);
        color: #1A1F2E;
        gap: 0.5rem;
    }
        .custom-filter-toggle svg {
    width: 16px;
    height: 16px;
}
      aside#main-collection-filters {
    position: absolute !important;
    top: 0;
    left: 20px;
    z-index: 1;
    width: 320px !important;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-15px);
    transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.3s !important;
    border-radius: 20px;
    border: 1px solid #F8F2E4;
    background: #fff;
    box-shadow: 0 4px 4px #00000040;
    padding: 2.5rem !important;
    height: max-content;
}
      aside#main-collection-filters.is-visible {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }
      .facet-filters__field .select:after { display: none !important; }
      .facet-filters__field .select:before { display: none !important; }
      aside#main-collection-filters .facets__heading--vertical { display: none !important; }
      .product-grid-container {
        width: 100% !important;
        flex: 1 1 100% !important;
      }
  `;
  document.head.appendChild(style);
});

